module.exports = __webpack_public_path__ + "fonts/apercu-regular-pro.48a036f.woff2";